import { Dropdown, Form } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Skeleton from "react-loading-skeleton"
import { UserStatus } from "../../types/userStatus"
import { faEllipsis, faPen } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import moment from "moment"

export type DataTable = {
    property: string,
    name: string,
    isName?: boolean,
    isStatus?: boolean,
    isNumber?: boolean,
    isEmail?: boolean,
    isDate?: boolean,
    isAction?: boolean,
    notShow?: boolean,
    isEnum?: boolean,
    enumFunc?: (id: any) => string
}

type UniModalProps = {
    dataTable: DataTable[],
    data: any
    error?: string,
    loading?: boolean,
    darkMode?: boolean,
    actionsHtml?: React.ReactNode,
    actionsEdit?: boolean,
    actionEdit?: (id: string) => void,
}

const UniModal = ({dataTable, data, actionsHtml, darkMode, error, loading, actionsEdit, actionEdit}: UniModalProps) => {
    const { t } = useTranslation();
    const mockStatusStyle = [
        {
            name: UserStatus.Active,
            color: '#30c10c',
            bgColor: '#eefff2',
        },
        {
            name: UserStatus.Inactive,
            bgColor: '#FFEFEA',
            color: '#FF6636',
        }
    ];

    return (
        <table className='table-uni'>
            <thead>
                <tr className='table-header' style={{paddingLeft: 10}}>
                    {
                        dataTable.map(header => {
                            if (header.notShow) return;

                            return (
                                <td key={header.name} style={header.isStatus ? {
                                    /*width: 1000,*/ textAlign: 'left'
                                } : header.isAction ? {width: 60, paddingRight: 20} : {}}
                                    className={``}>
                                    {
                                        header.isAction ?
                                        <>
                                            {header.name}
                                        </>
                                        :
                                        <>
                                            {header.name}
                                        </>
                                    }
                                </td>
                            )}
                        )
                    }
                </tr>
            </thead>
            {
                loading ? (
                    <Skeleton
                        width={'100%'}
                        height={400}
                        duration={1}
                        highlightColor={darkMode ? '#6c6b6b' : '#f5f5f5'}
                        baseColor={darkMode ? '#021717' : '#ebebeb'} />
                ) :
                (
                    error ?
                    (<p className='w-100 text-center p-2'>{t('customerScreen.searchNotFound')}</p>) :
                    <tbody>
                        {
                            data?.map((user: any, idx: number) => (
                                <tr className='item-header'>
                                    {
                                        dataTable.map(header => {
                                            if (header.notShow) {
                                                return;
                                            }

                                            if (header.isStatus) {
                                                return (
                                                    <td key={header.name} style={{ maxWidth: 60 }}>
                                                        <div className='table-status' style={{ backgroundColor: user?.[header.property] ? mockStatusStyle[0].bgColor : mockStatusStyle[1].bgColor ?? '#fff', minWidth: 145 }}>
                                                            <span className='table-status-icon' style={{ backgroundColor: user?.[header.property] ? mockStatusStyle[0].color : mockStatusStyle[1].color ?? '#fff' }}></span>
                                                            <div className='w-100' style={{ fontSize: 11 }}>{user?.[header.property] ? t('customerScreen.active') : t('customerScreen.inactive')}</div>
                                                        </div>
                                                    </td>
                                                );
                                            }

                                            if (header.property === 'check') {
                                                return (
                                                    <Form.Check
                                                        type={'checkbox'}
                                                        id={`default-check`}
                                                    />
                                                );
                                            }

                                            if (header.isNumber) {
                                                return (
                                                    <td key={header.name}>{Number(user?.[header.property])}</td>
                                                )
                                            }

                                            if (header.isDate) {
                                                return (
                                                    <td key={header.name}>{user?.[header.property] ? `${moment(user?.[header.property]).format('DD/MM/yyyy')}` : '-'}</td>
                                                )
                                            }

                                            if (header.isEmail) {
                                                return (
                                                    <td key={header.name} title={user?.[header.property]}>{user?.[header.property] ? user?.[header.property]?.length > 20 ? user?.[header.property]?.slice(0, 19) + '...' : user?.[header.property] : '-'}</td>
                                                )
                                            }

                                            if (header.isName) {
                                                return (
                                                    <td key={header.name} title={user?.[header.property]}>{user?.[header.property] ? user?.[header.property]?.length > 25 ? user?.[header.property]?.slice(0, 24) + '...' : user?.[header.property] : '-'}</td>
                                                )
                                            }

                                            if (header.isEnum) {
                                                return (
                                                    <td key={header.name} title={user?.[header.property]}>{header.enumFunc ? header.enumFunc(isNaN(Number(user?.[header.property])) ? user?.[header.property] : Number(user?.[header.property])) : user?.[header.property]}</td>
                                                )
                                            }

                                            if (header.property === 'actions') {
                                                return (
                                                    actionsEdit ? (
                                                        <td style={{width: 60}}>
                                                            <Dropdown>
                                                                <Dropdown.Toggle>
                                                                    <FontAwesomeIcon icon={faEllipsis}/>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu style={{padding: 0}}>
                                                                    <div className='d-flex flex-column actions gap-1'>
                                                                        <div
                                                                            className='action-icon'
                                                                            style={{border: `1px solid`, fontSize: 11}}
                                                                            onClick={() => {actionEdit ? actionEdit(user?.['id']) : console.log(`no action on prop`)}}
                                                                        >
                                                                            <FontAwesomeIcon icon={faPen}/>
                                                                            {t('edit')}
                                                                        </div>
                                                                    </div>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>
                                                    ) : (
                                                        <td>
                                                            {actionsHtml}
                                                        </td>
                                                    )
                                                );
                                            }

                                            return (
                                                <td key={header.name} title={user?.[header.property]}>{user?.[header.property] ? user?.[header.property]?.length > 10 ? user?.[header.property]?.slice(0, 23) + '...' : user?.[header.property] : '-'}</td>
                                            )
                                        })
                                    }
                                </tr>
                            ))
                        }
                    </tbody>
                )
            }
        </table>
    )
}

export default UniModal;